// The tools directory (EXP 03). Listing a tool does not grant access to it.
// Every link is either confirmed by the system owner or labelled as a
// placeholder.

import { esc } from '../api';
import type content from '../content/sample-content.json';
import { toolHref } from '../search';

export type Tool = (typeof content)['tools'][number];

const verifiedUrl = (tool: Tool): string | null => (tool.url && tool.linkStatus === 'owner-verified' ? tool.url : null);

export function toolLink(tool: Tool): string {
  const url = verifiedUrl(tool);
  if (url) {
    return `<a class="button" href="${esc(url)}" rel="noopener noreferrer" target="_blank">Sign in to ${esc(tool.name)}</a>`;
  }
  return `<span class="placeholder" title="Not yet confirmed by the system owner">Sign-in link placeholder</span>`;
}

// One quick-access link: a confirmed tool opens in a new tab; any other tool
// opens its entry in the directory, by the same rule as toolLink.
export function quickLink(tool: Tool): string {
  const url = verifiedUrl(tool);
  if (url) {
    return `<a href="${esc(url)}" rel="noopener noreferrer" target="_blank">${esc(tool.name)}<span aria-hidden="true"> ↗</span><span class="visually-hidden"> (opens in a new tab)</span></a>`;
  }
  return `<a href="${toolHref(tool.id)}">${esc(tool.name)}</a>`;
}

export function renderTools(tools: Tool[]): string {
  return `
<h1>Tools directory</h1>
<p class="muted">Each tool keeps its own access controls. Being listed here does not give you access.</p>
<ul class="tools">
${tools
  .map(
    (t) => `<li id="${esc(t.id)}" class="card">
  <h2>${esc(t.name)}</h2>
  <p>${esc(t.description)}</p>
  <p>${toolLink(t)}${t.overview ? ` <a href="${esc(t.overview)}">Overview</a>` : ''}</p>
</li>`,
  )
  .join('\n')}
</ul>`;
}
